import { render, staticRenderFns } from "./CrewRsrvDetails.vue?vue&type=template&id=ceb0b7f6&scoped=true&"
import script from "./CrewRsrvDetails.vue?vue&type=script&lang=js&"
export * from "./CrewRsrvDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ceb0b7f6",
  null
  
)

export default component.exports